import * as React from 'react';
import { Theme } from '@mui/material/styles';
import { IconButton, Box, Drawer, Toolbar, useMediaQuery } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { SearchResult } from '../../model/common-types';
import { SearchAutocomplete } from './search-autocomplete';

export interface HeaderSearchProps {
  searchUrl?: string;
  placeholder?: string;
  handleSearch: (search: string) => Promise<SearchResult[]>;
  onLoading?: (loading: boolean) => void;
  showSearchMore?: boolean;
}

export function HeaderSearch(props: HeaderSearchProps) {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const matchesXs = useMediaQuery((theme: Theme) => theme.breakpoints.only('xs'));

  return (
    <>
      <Box sx={{ display: 'inline-flex' }}>
        {matchesXs ? (
          <>
            <IconButton aria-label="search" color="inherit" onClick={() => setDrawerOpen(true)}>
              <SearchIcon />
            </IconButton>
            <Drawer color="default" anchor="top" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <SearchAutocomplete focused={true} {...props} onClose={() => setDrawerOpen(false)} />
                </Box>
                <Box>
                  <IconButton onClick={() => setDrawerOpen(false)}>
                    <CloseIcon />
                  </IconButton>
                </Box>
              </Toolbar>
            </Drawer>
          </>
        ) : (
          <SearchAutocomplete {...props} />
        )}
      </Box>
    </>
  );
}
